<template>
	<v-navigation-drawer
		width="200"
		v-model="navigationToggle"
		app
		color="primary"
		:right="$i18n.locale === 'ar'">
		<div
			class="d-flex flex-column justify-space-between fill-hight"
			style="height: 99vh">
			<div class="px-0 py-2">
				<a href="/">
					<v-img
						class="mx-auto"
						src="@/assets/fps.png"
						max-width="6.5rem"></v-img>
				</a>
			</div>
			<v-list
				class="mb-auto"
				nav
				dark>
				<template v-for="(page, index) in pages">
					<v-divider
						:key="index"
						v-if="page.divider"
						class="my-2 white"
					></v-divider>
					<v-list-item
						v-else
						:key="index"
						:to="{ name: page.target }"
						exact-path
						class="mb-0"
					>
						<v-list-item-icon class="me-2">
							<v-icon>{{ page.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							{{ page.title }}
						</v-list-item-content>
						<v-list-item-icon
							class="me-2"
							v-if="page.target === 'employees'">
							<router-link :to="{ name: 'employees', query: { search: true } }">
								<v-icon>mdi-magnify</v-icon>
							</router-link>
						</v-list-item-icon>
					</v-list-item>
				</template>
			</v-list>
			<v-list
				nav
				dark>
				<v-list-item :to="{ name: 'settings' }">
					<v-list-item-icon class="me-2">
						<v-icon>mdi-cog</v-icon>
					</v-list-item-icon>
					<v-list-item-content> الإعدادات </v-list-item-content>
				</v-list-item>
			</v-list>
			<div class="text-center white--text text-caption">Beehive v{{ VERSION }}</div>
		</div>
	</v-navigation-drawer>
</template>

<script>
import { VERSION } from '@/utils/constants';
export default {
	name: 'NavigationDrawer',
	props: {
		navToggle: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			VERSION,
		};
	},

	computed: {
		navigationToggle: {
			set(newVal) {
				this.$emit('update:navToggle', newVal);
			},
			get() {
				return this.navToggle;
			},
		},

		pages() {
			return [
				{
					target: 'sections',
					title: this.$T('sections'),
					icon: 'mdi-file-tree-outline mdi-flip-h',
				},
				{
					target: 'employees',
					title: this.$T('employees'),
					icon: 'mdi-account-multiple',
				},
				{
					target: 'attendance',
					title: this.$T('work'),
					icon: 'mdi-calendar-edit',
				},
				{
					target: 'salaries',
					title: this.$T('salaries'),
					icon: 'mdi-cash',
				},
				{
					target: 'penalties-and-rewards',
					title: this.$T('penalties-and-rewards'),
					icon: 'mdi-scale-balance',
				},
				{ divider: true },
				// {
				// 	target: 'trainings',
				// 	title: this.$T('trainings'),
				// 	icon: 'mdi-human-male-board',
				// },
				{
					target: 'reminders',
					title: this.$T('reminders'),
					icon: 'mdi-alarm',
				},
				// {
				// 	target: 'interviews',
				// 	title: 'المقابلات و التقييمات',
				// 	icon: 'mdi-calendar-edit',
				// },
				// {
				// 	target: 'evaluations',
				// 	title: this.$T('evaluations'),
				// 	icon: 'mdi-clipboard-check-outline',
				// }, 
				// TODO // FIXME remove /interview/* files, routes and translates
				// {
				// 	target: 'interviews',
				// 	title: this.$T('interviews'),
				// 	icon: 'mdi-clipboard-check-outline',
				// },
			];
		},
	},
};
</script>
